// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"19":"2e75298a","387":"5874f7a3","573":"6faf04c5","681":"648b7841","793":"28a81c3a","799":"ad9cc554","840":"648b7841","983":"8329bed9"}[chunkId] + ".chunk.css";
};